<template>
  <v-app-bar>
    <template v-for="(slotContent, slotName) in $slots" :key="slotName">
      <slot :name="slotName">
        {{ slotContent }}
      </slot>
    </template>
  </v-app-bar>
</template>

<script setup lang="ts"></script>
